export class WinnerModel {
    txHash?: string;
    gameId: string;
    winner: string;
    round: number;
    amount?: number;
    date: any;
}